import script from "./powerManage.vue?vue&type=script&setup=true&lang=js"
export * from "./powerManage.vue?vue&type=script&setup=true&lang=js"

import "./powerManage.vue?vue&type=style&index=0&id=19c787ef&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c787ef"]])

export default __exports__